import tracking from 'dibs-tracking';

function trackSocialIntegration({ label }) {
    tracking.trackEvent({
        action: 'facebook',
        category: 'social integrations',
        label,
        value: 0,
    });
}

export function trackAccountConnectionClick() {
    trackSocialIntegration({ label: 'connect account entry|account information' });
}

export function trackAccountConnectionSuccess() {
    trackSocialIntegration({ label: 'connect account successful|account information' });
}

export function trackAccountDisconnectSuccess() {
    trackSocialIntegration({ label: 'disconnect account successful|account information' });
}

export function trackSupportArticleCenterClick() {
    trackSocialIntegration({ label: 'learn how clicked - my account' });
}



// WEBPACK FOOTER //
// ./assets/js/global/components/Facebook/trackingHelpers.es.js